import React, { useState } from "react";
// import dayjs from "dayjs";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Calendar.css";

import CalendarDesktop from "../components/CalendarDesktop";
import CalendarMobile from "../components/CalendarMobile";

const Calendar = () => {
  return (
    <div className="container mt-6">
      <div className="card">
        <div className="card-block">
          <CalendarDesktop />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4">
          <div className="card">
            <div className="calendar-container">
              <div className="card-header">
                <h3 className="h5">Mobile View Calendar</h3>
              </div>
              <div className="card-block">
                <CalendarMobile />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
